<br><br>

<button type="button" *ngFor="let option of options;" class="btn btn-outline-primary" style="border-radius: 45px;" (click)="add(option.id)" [hidden]="!added(option.id)">
  <i class="fa fa-times-circle" aria-hidden="true"></i> &nbsp; {{option.name}}
</button>

<br><br>

<form class="example-form">
  <mat-form-field>
    <input type="text" style="color: grey;" placeholder="{{placeholder}}" aria-label="Assignee" matInput [formControl]="myControl" [matAutocomplete]="auto">
    <mat-autocomplete style="background-color: white;" (optionSelected)="setValue($event.option.value)" #auto="matAutocomplete" [displayWith]="displayFn">

      <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
        <i class="fa {{added(option.id) || (option.id === 'All' && (options.length - 1) === idsVlues.length) ? 'fa-check-square' : 'fa-square-o'}}" aria-hidden="true"></i>
        &nbsp; {{option.name}}
      </mat-option>

    </mat-autocomplete>
  </mat-form-field>
</form>